
import React from 'react';
import { staffRoles } from '../dashboard/available-staff/data';

const StaffRolesSection = () => {
  return (
    <section className="py-16 bg-gradient-to-b from-background to-muted/20">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-12">
          <h2 className="text-3xl font-bold mb-4">Meet Your AI Staff Team</h2>
          <p className="text-muted-foreground">
            VirtuStaff.ai provides specialized AI assistants for different business functions.
            Each assistant comes with unique skills tailored to their role.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {staffRoles.map((role) => (
            <div 
              key={role.role} 
              className={`rounded-lg p-6 border transition-all hover:shadow-md 
                ${role.status === 'available' ? 'bg-card' : 'bg-muted/50 opacity-80'}`}
            >
              <div className="flex flex-col h-full">
                <div className="mb-4 text-4xl">{role.icon}</div>
                <h3 className="text-xl font-bold mb-2">
                  {role.title}
                  {role.status !== 'available' && (
                    <span className="ml-2 text-xs font-normal py-1 px-2 bg-muted rounded-full">
                      Coming Soon
                    </span>
                  )}
                </h3>
                <p className="text-muted-foreground mb-4 flex-grow">{role.description}</p>
                <div className="flex flex-wrap gap-1 mt-auto">
                  {role.skills.slice(0, 3).map((skill) => (
                    <span key={skill} className="text-xs py-1 px-2 bg-muted rounded-full">
                      {skill}
                    </span>
                  ))}
                  {role.skills.length > 3 && (
                    <span className="text-xs py-1 px-2 bg-muted rounded-full">
                      +{role.skills.length - 3} more
                    </span>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StaffRolesSection;
